import { Injectable } from "@angular/core";
import { GeneralStore } from "../store/general";
import cloneDeep from "clone-deep";

@Injectable({
    providedIn: 'root'
})
export class FieldsFormStateService {

    constructor(
        private generalStore: GeneralStore
    ) {

    }

    setFormState(key: string, value: any) {
        const formState = cloneDeep(this.generalStore.getSnapshot().formState);
        formState[key] = value;
        this.generalStore.setFormState(formState);
    }


}

